<script setup lang="ts">
interface Props {
	drawNumber: number;
}
const props = defineProps<Props>();

const avatar = computed(() => {
	switch (props.drawNumber) {
		case 1:
			return { style: "background: rgb(255, 0, 0)", class: "text-light-50" };
		case 2:
			return { style: "background: #1E90FF", class: "text-light-50" };
		case 3:
			return { class: "bg-light-200 dark:text-dark-800" };
		case 4:
			return { class: "bg-dark-700 text-light-50" };
		case 5:
			return { style: "background: #FF9B12" };
		case 6:
			return {
				style:
					"background: linear-gradient(180deg, #000, #000 50%, #fff 0, #fff);background-size: 100% 12px; color: red;text-shadow: -1.5px -1.5px 0 #FFF, 1.5px -1.5px 0 #FFF, -1.5px 1.5px 0 #FFF, 1.5px 1.5px 0 #FFF",
			};
	}
});
</script>

<template>
	<div :class="[avatar?.class, 'flex items-center justify-center font-bold text-lg rounded-sm']" class="w-7 h-7" :style="avatar?.style">
		{{ drawNumber }}
	</div>
</template>
